import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { strings } from '../resources/strings.js';
import { LinkContainer } from 'react-router-bootstrap';

export class Footer extends Component {

    render() {
        const { marginClass } = this.props;

        return (
            <div>
                <Container fluid>
                    <div className={`footer ${marginClass}`}>
                        <p>
                            <a href="https://www.opt.pt" target="_blank" rel="noopener noreferrer">{strings.copyright}</a>. {strings.developedFor}. {strings.allRightsReserved}. <a href="https://www.livroreclamacoes.pt/" target="_blank" rel="noopener noreferrer">{strings.complaintsBook}</a> | <LinkContainer to="/privacypolicy"><a href="/privacypolicy">{strings.privacyPolicy}</a></LinkContainer>
                        </p>
                    </div>
                </Container>
            </div>
        )
    }
}